export const Size = {
  Small: "small",
  Medium: "medium",
  Large: "large"
}

export const Rounding = {
  None: "none",
  Full: "full",
  Left: "left",
  Right: "right"
}

export const Style = {
  Primary: "primary",
  Subtle: "subtle"
}